<app-loader [isLoading]="isLoading"></app-loader>

<!-- Only show content when element is loaded -->
@if (element) {
<div class="header">
    <div class="top">
        <a routerLink="/home/communication/mailbox">
            <h3>Buzón /</h3>
            <div class="breadcrumb">
                <mat-icon svgIcon="arrow back"></mat-icon>
                <h2> {{element?.title}}</h2>
            </div>
        </a>
    </div>
</div>
<div class="content form">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">

        <mat-tab label="Detalles">
            <h4>Título: <span>{{element?.title}}</span></h4>
            <h4>Contenido:</h4>
            <p [innerHTML]="element?.content"></p>
            <h4>Autor: <span>{{element?.employee_external_id | qeqPipe}}</span></h4>
            <h4>Fecha envío: <span>{{element?.created_when | timezoneAdjust | customPipe}}</span></h4>
            <h4>Tipo: <span>{{element?.types}}</span></h4>
            <form [formGroup]="suggestionForm">
                <h4>Estado: </h4>
                <mat-form-field appearance="outline">
                    <mat-select formControlName="toppings">
                        @for (topping of toppingList; track topping) {
                        <mat-option [value]="topping">{{topping}}</mat-option>
                        }
                    </mat-select>
                    @if(toppings?.invalid && (toppings?.dirty || toppings?.touched)) {
                    <mat-error>El estado es requerido</mat-error>
                    }
                </mat-form-field>

                <h4>Observaciones: </h4>
                <quill-editor formControlName="observation" [modules]="modules" [styles]="{height: '300px'}"
                    (onEditorCreated)="onEditorCreated($event)"></quill-editor>
                <!-- Always show error message container, but only populate with errors when needed -->
                <div class="error-message">
                    @if (observation?.invalid && (observation?.dirty || observation?.touched)) {
                    @if (observation?.errors?.['required']) {
                    <p class="error">La observación es requerida.</p>
                    }
                    @if (observation?.errors?.['minlength']) {
                    <p class="error">La observación debe tener al menos 10 caracteres.</p>
                    }
                    }
                </div>

                <div class="buttons">
                    <!-- Remove type="submit" and use (click) to ensure we handle validation properly -->
                    <button mat-flat-button id="action" type="button" (click)="saveChanges()">
                        Guardar cambios
                    </button>
                    <button mat-flat-button id="cancel" type="button"
                        routerLink="/home/communication/mailbox">Cancelar</button>
                </div>
            </form>
        </mat-tab>

        <mat-tab label="Historial">
            <mat-paginator [pageSizeOptions]="[25, 50, 100]" aria-label="Select page of the relation table"
                class="paginator-field">
            </mat-paginator>
            <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)"
                class="mat-elevation-z8" id="restaurant-table">

                <!-- Columna de Observación -->
                <ng-container matColumnDef="observation">
                    <th mat-header-cell *matHeaderCellDef>
                        OBSERVACIÓN
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <span style="font-size: 16px;" [innerHTML]="element.reason"></span>
                    </td>
                </ng-container>

                <!-- Columna de Estado -->
                <ng-container matColumnDef="new_status">
                    <th mat-header-cell *matHeaderCellDef>
                        ESTADO
                    </th>
                    <td mat-cell *matCellDef="let element">
                        @if(element.status === 'Aceptada'){
                        <button mat-flat-button id="consumed">
                            <mat-icon matTextPrefix>check_circle</mat-icon>
                            <span style="font-size: 16px;">{{element.status}}</span>
                        </button>
                        }@else if (element.status === 'En trámite') {
                        <button mat-flat-button id="reservation">
                            <mat-icon matTextPrefix svgIcon="pending"></mat-icon>
                            <span style="font-size: 16px;">{{element.status}}</span>
                        </button>
                        }@else if (element.status === 'Declinada') {
                        <button mat-flat-button id="non-consumed">
                            <mat-icon matTextPrefix>cancel</mat-icon>
                            <span style="font-size: 16px;">{{element.status}}</span>
                        </button>

                        } @else {
                        <button mat-flat-button id="started">
                            <mat-icon matTextPrefix svgIcon="psychology"></mat-icon>
                            <span style="font-size: 16px;">{{element.status}}</span>
                        </button>
                        }
                    </td>
                </ng-container>

                <!-- Columna de Actualización de estado -->
                <ng-container matColumnDef="updated_status_date">
                    <th mat-header-cell *matHeaderCellDef>
                        ACTUALIZACIÓN DE ESTADO
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <span style="font-size: 16px;">{{element.changed_at | timezoneAdjust | customPipe }}</span>
                    </td>
                </ng-container>



                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                </tr>
            </table>
        </mat-tab>
    </mat-tab-group>
</div>
}